import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtMoney } from "@/lib/api";
import { Trash2, Eye } from "lucide-react";

const STATUS_COLORS = {
  unpaid: "text-[var(--secondary)] border-[var(--secondary)]",
  paid: "text-[var(--primary)] border-[var(--primary)]",
  overdue: "text-[var(--error)] border-[var(--error)]",
};

export default function Invoices() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/invoices").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete invoice?")) return;
    await api.delete(`/invoices/${id}`);
    load();
  };

  const setStatus = async (id, status) => {
    await api.patch(`/invoices/${id}/status`, { status });
    load();
  };

  return (
    <div className="stagger-in">
      <div className="label-mono">/ INVOICES</div>
      <h1 className="font-display text-5xl tracking-tight mt-2">Invoices</h1>
      <p className="text-zinc-400 mt-2">Print, share, mark as paid.</p>

      <div className="mt-10 border border-[var(--border)] overflow-x-auto" data-testid="invoices-list">
        <div className="min-w-[720px]">
        <div className="grid grid-cols-12 gap-0 text-xs font-mono uppercase tracking-wider text-zinc-500 border-b border-[var(--border)]">
          <div className="col-span-3 p-3">Number</div>
          <div className="col-span-3 p-3 border-l border-[var(--border)]">Client</div>
          <div className="col-span-2 p-3 border-l border-[var(--border)]">Total</div>
          <div className="col-span-2 p-3 border-l border-[var(--border)]">Status</div>
          <div className="col-span-2 p-3 border-l border-[var(--border)]" />
        </div>
        {items.length === 0 && (
          <div className="p-10 text-center text-zinc-500 font-mono text-sm">
            No invoices yet.
          </div>
        )}
        {items.map((inv) => (
          <div
            key={inv.id}
            className="grid grid-cols-12 gap-0 text-sm font-mono border-b border-[var(--border)] last:border-b-0"
            data-testid={`invoice-row-${inv.id}`}
          >
            <div className="col-span-3 p-3">{inv.invoice_number}</div>
            <div className="col-span-3 p-3 border-l border-[var(--border)] truncate text-zinc-400">
              {inv.client_name || "—"}
            </div>
            <div className="col-span-2 p-3 border-l border-[var(--border)] text-[var(--primary)]">
              {fmtMoney(inv.total)}
            </div>
            <div className="col-span-2 p-3 border-l border-[var(--border)]">
              <select
                value={inv.status}
                onChange={(e) => setStatus(inv.id, e.target.value)}
                className={`bg-transparent border px-2 py-1 text-xs uppercase tracking-wider ${
                  STATUS_COLORS[inv.status] || "text-zinc-400 border-[var(--border)]"
                }`}
                data-testid={`invoice-status-${inv.id}`}
              >
                <option value="unpaid">Unpaid</option>
                <option value="paid">Paid</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>
            <div className="col-span-2 border-l border-[var(--border)] flex">
              <Link
                to={`/app/invoices/${inv.id}`}
                className="flex-1 border-r border-[var(--border)] text-zinc-500 hover:text-[var(--primary)] flex items-center justify-center"
                data-testid={`invoice-view-${inv.id}`}
              >
                <Eye size={14} />
              </Link>
              <button
                onClick={() => remove(inv.id)}
                className="flex-1 text-zinc-500 hover:text-[var(--error)] flex items-center justify-center"
                data-testid={`invoice-delete-${inv.id}`}
              >
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
        </div>
      </div>
    </div>
  );
}
